<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="450" v-model="searchModal" style="z-index: 99999999">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="عنوان" class="input-label"
                prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="showAddEditModal" persistent style="z-index: 99999999">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" v-model="flagData.title" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="showConfirmDialogFunction()" label="عنوان*" class="input-label"
                prepend-inner-icon="mdi-text-box mdi-18px" :autofocus="true"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="flagData.code" dense
                outlined v-on:keyup.enter="showConfirmDialogFunction()" label="کد" class="input-label"
                prepend-inner-icon="mdi-barcode mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!addFlag">
              <v-checkbox v-model="isActive" label="نمایش" hide-details tabindex="3"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="table">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleIMG" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت کدهای گوشی</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن کد گوشی
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="flagDataManagmentInformationTableHeaders"
                          :items="flagDataFilteredList" :page.sync="page" :items-per-page="flagDataFilteredList.length"
                          height="65vh" :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.status`]="{ item }">
                            <v-tooltip top v-if="item.status == false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#F56060" v-bind="attrs" v-on="on">
                                  mdi-eye-off
                                </v-icon>
                              </template>
                              <span>عدم نمایش</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#3BCA79" v-bind="attrs" v-on="on">
                                  mdi-eye
                                </v-icon>
                              </template>
                              <span>نمایش</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <v-spacer></v-spacer>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                            <v-spacer></v-spacer>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle color="iconColor" v-model="page" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import PaginationComponent from '../../components/PaginationComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import flagDataMixin from '@/Mixins/BaseInformation/FlagDataMixin';
import flagDataHelper from '@/Helpers/BaseInformation/FlagDataHelper';
export default {
  name: 'FlagDataManagment',
  title: 'کدهای گوشی',
  inject: ['load'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
  },
  mixins: [pagination, ShearedMixin, flagDataMixin, flagDataHelper, snackBar, ShearedHelper],
  created() {
    this.$root.$refs.FlagDataManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      tableTitleIMG: require('@/assets/images/tableTitleIMG.png'),
      table: require('@/assets/images/table.png'),
    };
  },
  methods: {
    mounte: function () {
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfFlagDatasWithPagination();
    },
    previous: function () {
      this.getListOfFlagDatasWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfFlagDatasWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfFlagDatasWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {
    flagDataFilteredList() {
      return this.flagDataPaginationList.filter((u) => {
        return (
          u.title.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          u.code.toLowerCase().includes(this.searchTitle.toLowerCase())
        );
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--modal-border-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--modal-border-color);
}

.modal-title-text {
  color: var(--modal-border-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
